<script setup lang="ts">
import { getOrders } from '@caks/shared/api/user.route'
import { isoToFullTime } from '@caks/shared/utils/timeHelpers'
import { CommonTitle } from '../common'
import { ButtonMain } from '@caks/uikit/button'
import { ISeparatedItem } from '@caks/shared/modules/i'
import { ItemsInOrder, OrderFromHistory } from '@caks/shared/types/types.api'

const orders = ref<
  Array<{
    id: number
    time: string
    location: string
    price: number
    images: Array<string>
  }>
>([])

const calcCost = (items: ItemsInOrder[]) => {
  return items.reduce((accumulator, currentValue) => accumulator + currentValue.total_amount, 0)
}

const addressString = (address: OrderFromHistory['address']) => {
  if (address) {
    return `${address.city}, ${address.street}, ${address.house_number}`
  } else {
    return 'Нет данных'
  }
}

onMounted(async () => {
  const { data } = await getOrders()
  for (const item of data) {
    orders.value.push({
      id: item._id,
      time: isoToFullTime(item.created_at),
      location: addressString(item.address),
      price: calcCost(item.items_in_order),
      images: item.items_in_order.map(item => item.main_media),
    })
  }
})
</script>

<template>
  <div class="orders">
    <common-title title="История заказов" />
    <p class="orders__description">Последние 20 заказов за последние 90 дней</p>
    <ul class="orders__list">
      <div class="orders-wrapper">
        <article
          class="order"
          v-for="order of orders"
          @click="$router.push(`/profile/orders/${order.id}`)"
        >
          <i-separated-item first>
            <div class="order__option">
              {{ order.time }}
            </div>
          </i-separated-item>
          <i-separated-item>
            <div class="order__option">
              {{ order.location }}
            </div>
          </i-separated-item>
          <i-separated-item>
            <div class="order__images">
              <img v-for="imagePath of order.images" :src="imagePath" alt="" />
            </div>
          </i-separated-item>
          <i-separated-item last>
            <div class="order__price">
              <span>Сумма</span>
              <span>{{ order.price }}₽</span>
            </div>
          </i-separated-item>
          <button-main class="order__button">Повторить заказ</button-main>
        </article>
      </div>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.orders {
  display: flex;
  flex-direction: column;
  gap: 24px;

  h3 {
    margin-bottom: 8px;
  }

  &__description {
    @include h5-2;
    color: $sub-text;
  }

  &__list {
    display: flex;
    gap: 24px;
    margin-bottom: 8px;
  }
}

.orders-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
}
.order {
  @include h4-8;
  color: $sub-text;
  padding: 16px;
  border-radius: 8px;
  background-color: $white;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);

  &__images {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    > img {
      min-width: 56px;
      min-height: 56px;
      max-width: 56px;
      max-height: 56px;
    }
  }

  &__option {
    height: 44px;
    display: flex;
    align-items: center;
  }

  &__price {
    color: $primary-text;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
  }

  &__button {
    display: flex;
    width: 100%;
    margin-top: 16px;
  }
}
</style>
